import React from "react";
import TablePagination from "../NewPagination/NewPagination";
import { Table } from "react-bootstrap";
import ProfileImg from "../../../../assets/images/Profile.svg";
import { useSelector } from "react-redux";

import "./table.css";

const GenericTable = ({
  title = "",
  columns = [],
  data = [],
  allData = [],
  currentPage = 1,
  totalPages = 1,
  onPageChange = () => {},
  noDataMessage = "No data found",
  stylingComp = {},
  showCheckbox = false,
  selectedRows = [],
  onRowSelect = () => {},
  onSelectAll = () => {},
  showSelectAllCheckbox = false,
  onSort = null,
  sortConfig = null,
}) => {
  // Calculate if all rows are selected (check against all data, not just current page)
  const user = useSelector((state) => state?.user?.user);
  const dataToCheck = allData.length > 0 ? allData : data;
  const allRowsSelected =
    dataToCheck.length > 0 &&
    dataToCheck.every((row) => {
      const rowIdentifier = row.id || dataToCheck.indexOf(row);
      return selectedRows.includes(rowIdentifier);
    });

  // Handle select all checkbox
  const handleSelectAll = () => {
    onSelectAll(!allRowsSelected);
  };

  return (
    <div className={`GenericTableCard`} style={stylingComp}>
      {/* <div className="row">
        <div className="col-lg-6 col-md-6 col-12"></div>
        <div className="col-lg-6 col-md-6 col-12"></div>
      </div> */}
      <div className="m-0">
        <div className="w-100">
          <div className="TableBox">
            <Table>
              <thead>
                <tr>
                  {showSelectAllCheckbox && (
                    <th style={{ width: "24px" }}>
                      <div className="checkbox-container">
                        <input
                          type="checkbox"
                          checked={allRowsSelected}
                          onChange={handleSelectAll}
                          className="table-checkbox"
                        />
                      </div>
                    </th>
                  )}
                  {columns.map((col, index) => (
                    <th key={index} style={{ width: col.width || "auto" }}>
                      <div className="d-flex gap-2 align-items-center">
                        <p className="mb-0 text-nowrap">{col.label}</p>
                        {col.sortable !== false && onSort && (
                          <div 
                            className="sortingFilters"
                            onClick={() => onSort(col.key)}
                          >
                            <svg 
                              className={`${sortConfig?.key === col.key && sortConfig?.direction === 'asc' ? 'text-black opacity-100' : 'opacity-25'}`} 
                              aria-hidden="true" 
                              xmlns="http://www.w3.org/2000/svg" 
                              width="12" 
                              height="12" 
                              fill="currentColor" 
                              viewBox="0 0 24 24"
                              style={{ marginBottom: "-4px" }}
                            >
                              <path fillRule="evenodd" d="M5.575 13.729C4.501 15.033 5.43 17 7.12 17h9.762c1.69 0 2.618-1.967 1.544-3.271l-4.881-5.927a2 2 0 0 0-3.088 0l-4.88 5.927Z" clipRule="evenodd"/>
                            </svg>
                            <svg
                              className={`${sortConfig?.key === col.key && sortConfig?.direction === 'desc' ? 'text-black opacity-100' : 'opacity-25'}`} 
                              aria-hidden="true" 
                              xmlns="http://www.w3.org/2000/svg" 
                              width="12" 
                              height="12" 
                              fill="currentColor" 
                              viewBox="0 0 24 24"
                            >
                              <path fillRule="evenodd" d="M18.425 10.271C19.499 8.967 18.57 7 16.88 7H7.12c-1.69 0-2.618 1.967-1.544 3.271l4.881 5.927a2 2 0 0 0 3.088 0l4.88-5.927Z" clipRule="evenodd"/>
                            </svg>
                          </div>
                        )}
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.length === 0 ? (
                  <tr>
                    <td
                      colSpan={
                        showCheckbox ? columns.length + 1 : columns.length
                      }
                      className="text-center py-4"
                    >
                      {noDataMessage}
                    </td>
                  </tr>
                ) : (
                  data.map((row, rowIndex) => {
                    const rowIdentifier = row.id || rowIndex;
                    const isSelected = selectedRows.includes(rowIdentifier);

                    return (
                      <tr
                        key={rowIdentifier}
                        className={isSelected ? "selected-row" : ""}
                      >
                        {showCheckbox && (
                          <td>
                            <div className="checkbox-container">
                              <input
                                type="checkbox"
                                checked={isSelected}
                                onChange={() => onRowSelect(row, rowIndex)}
                                className="table-checkbox"
                              />
                            </div>
                          </td>
                        )}
                        {columns.map((col, colIndex) => {
                          let cellContent;
                          let customClass = "";
                          if (typeof col.render === "function") {
                            cellContent = col.render(row);
                          } else {
                            const cellData = row[col.key];
                            const cellSmallData = row[col?.keySmall];
                            let displayValue = cellData;
                            if (
                              typeof cellData === "object" &&
                              cellData !== null
                            ) {
                              displayValue = cellData.value || "-";
                              customClass = cellData.className || "";
                            }
                            cellContent = (
                              <>
                                {displayValue || "-"}{" "}
                                <span>{cellSmallData}</span>
                              </>
                            );
                          }
                          const handleClick = () => {
                            if (typeof col.onClick === "function") {
                              col.onClick(row);
                            }
                          };
                          const marketValue = row?.tradeMarket;
                          const isMarketNotConnected =
                            col.key === "tradeMarket" &&
                            (!marketValue ||
                              marketValue === "-" ||
                              marketValue === "None" ||
                              marketValue === "Not Connected");
                          return (
                            <td
                              key={colIndex}
                              onClick={col.onClick ? handleClick : undefined}
                              style={{
                                cursor: col.onClick ? "pointer" : "default",
                              }}
                            >
                              <div
                                style={{
                                  whiteSpace:
                                    col.key === "time" ||
                                    col.key === "tradeMarket"
                                      ? "nowrap"
                                      : "",
                                }}
                                className="profileItem"
                              >
                                {col.type === "profile" && (
                                  <img src={row?.logo || ProfileImg} alt="profile" />
                                )}
                                <p
                                  className={customClass}
                                  style={
                                    col.key === "tradeMarket"
                                      ? {
                                          whiteSpace: "nowrap",
                                          ...(isMarketNotConnected
                                            ? { paddingRight: "10px" }
                                            : {}),
                                        }
                                      : undefined
                                  }
                                >
                                  {cellContent}
                                </p>
                              </div>
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
      {totalPages > 0 && (
        <div className="genericTableFooter">
          <TablePagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
          />
        </div>
      )}
    </div>
  );
};

export default GenericTable;
